export const NODE_TYPE_DRAG_DATA_FORMAT = "application/flow-builder.node-type";
